import { HuitabModal } from '../../../../shared/components/common/huitab-modal';
import { ComponentHelper } from '../../../../shared/services/component-helper';
import { TagCommanderManager } from '../../../../shared/services/tag-commander-manager';

export class ModalSupprimerInterlocuteur extends HuitabModal {
  /**
   * @param {string} codeService - Type de service (ex: 'COUPURE' ou 'PCP')
   */
  codeService;

  /**
   * Initialise une nouvelle instance de type {@type ModalSupprimerInterlocuteur}.
   */
  constructor() {
    super('modal-supprimer-interlocuteur');

    this.codeService = null;

    this.onDismiss(() => {
      TagCommanderManager.tagClick({
        chapitre_1: 'mon_reseau_electrique',
        chapitre_2: 'interlocuteurs_prevenance',
        chapitre_3: 'voir_interlocuteur',
        page: 'annuler_suppression',
        type: 'action',
      });
    });

    this.onAccept(() => {
      ComponentHelper.pymSendMessage('supprimerInterlocuteur');
      if (this.codeService === 'COUPURE') {
        TagCommanderManager.tagClick({
          chapitre_1: 'mon_reseau_electrique',
          chapitre_2: 'interlocuteurs_prevenance',
          chapitre_3: 'voir_interlocuteur',
          page: 'confirmer_suppression_hta',
          type: 'action',
        });
      } else if (this.codeService === 'PCP') {
        TagCommanderManager.tagClick({
          chapitre_1: 'mon_reseau_electrique',
          chapitre_2: 'interlocuteurs_prevenance',
          chapitre_3: 'voir_interlocuteur',
          page: 'confirmer_suppression_travaux',
          type: 'action',
        });
      }

    });
  }

  setCodeService(codeService) {
    this.codeService = codeService;
  }
}
